export default "__VITE_ASSET__0iYZQrnM__"